/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import Home from '../../icons/Home.svg?react';
import Tooltip from '@mui/material/Tooltip';

const linkButtonStyle = css`
  display: flex;
  align-items: center;
  padding: 0 10px;
  min-height: 60px;
  &:hover: {
    background-color: #DBE4E9;
  };
  margin-top: -4px;
`;

interface IProps {
  hrefLink: string;
  tooltipTitle?: string;
  tooltipPlacement?: 
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';
  tooltipArrow?: boolean;  
}

/**
 * @name MikeHomeButton
 * @summary A home button to be placed into the topbar.
 */
const MikeHomeButton = (props: IProps) => {  
  const { hrefLink, tooltipTitle, tooltipArrow, tooltipPlacement } = props;
 
  if (tooltipTitle){
    return (
      <Tooltip title={tooltipTitle} arrow={tooltipArrow} placement={tooltipPlacement}>
        <a css={linkButtonStyle} target="_blank" href={hrefLink}>
          <Home />
        </a>
      </Tooltip>
 
    ); 
  }
  else{
    return (
      <a css={linkButtonStyle} target="_blank" href={hrefLink}>
        <Home />
      </a>
    ); 
  }
     
}

export default MikeHomeButton;
